import React from 'react'
import {useTranslation} from 'react-i18next'

import {useFormInputLabelWithSuffix} from '../../hooks'
import {getTranslationKey} from '../../utils'
import {ProcessStageAutocomplete} from '../processFormFields'

type Props = {
  plantId: string
  errorText?: React.ReactNode
  onChange: (processStage: string | undefined) => void
  value?: string
  required?: boolean
  disabled?: boolean
  translationPrefix?: string
}

export const EventProcessStageAutocomplete = (props: Props) => {
  const {t} = useTranslation()

  const label = useFormInputLabelWithSuffix({
    label: t(getTranslationKey('shiftEvent.label.processStage', props.translationPrefix)),
    optional: !props.required,
    optionalTKey: getTranslationKey('shiftEvent.label.optional', props.translationPrefix)
  })

  return <ProcessStageAutocomplete label={label} {...props} />
}
